import { cva } from 'class-variance-authority';

export const cvaRoot = cva([
  'ReviewPopupStyles-cvaRoot',
  'fixed left-0 top-0 z-[200]',
  'w-full h-full',
  'px-[14rem] py-4',
]);

export const cvaOverlay = cva([
  'ReviewPopupStyles-cvaOverlay',
  'absolute left-0 top-0 ',
  'w-full h-full',
  'bg-cBlack32',
]);

export const cvaClose = cva([
  'ReviewPopupStyles-cvaClose',
  'flex items-center justify-center',
  'absolute top-4 right-2.4',
  'w-5.6 h-5.6',
  'bg-cWhite',
  'rounded-[1.6rem]',
  'cursor-pointer select-none',
]);

export const cvaCloseIcon = cva(['ReviewPopupStyles-cvaCloseIcon', 'w-1.6 h-1.6', 'fill-cBlack']);

export const cvaInner = cva([
  'ReviewPopupStyles-cvaInner',
  'relative overflow-hidden',
  'flex',
  'w-f h-full',
  'rounded-[3.2rem]',
  'bg-cWhite',
]);

export const cvaGalleryWrap = cva(['ReviewPopupStyles-cvaGalleryWrap', 'relative', 'flex-1', 'w-[calc(100%-33.9rem)]']);

export const cvaGallery = cva(['ReviewPopupStyles-cvaGallery', 'h-full']);

export const cvaGallerySlide = cva(['ReviewPopupStyles-cvaGallerySlide', '']);

export const cvaGallerySlideLabel = cva(
  [
    'ReviewPopupStyles-cvaGallerySlideLabel',
    'absolute z-[2] right-3.2 top-3.2',
    'py-0.6 px-1.2 pb-1',
    'text-center text-cWhite text-labelL font-semibold',
    'rounded-[1.2rem]',
  ],
  {
    variants: {
      type: {
        before: ['bg-cRed'],
        after: ['bg-cMediumGreen'],
      },
    },
  }
);

export const cvaGallerySlideImage = cva([
  'ReviewPopupStyles-cvaGallerySlideImage',
  'z-[1]',
  'object-contain object-center',
]);

export const cvaGallerySlideBg = cva([
  'ReviewPopupStyles-cvaGallerySlideBg',
  'object-center object-cover',
  '[filter:blur(1rem)]',
]);

export const cvaGalleryButton = cva(
  [
    'ReviewPopupStyles-cvaGalleryButton',
    'flex items-center justify-center',
    'absolute top-1/2 z-[2]',
    '-mt-2.4',
    'w-4.8 h-4.8',
    'bg-cWhite',
    'rounded-[1.6rem]',
    '[&.swiper-button-disabled]:hidden',
  ],
  {
    variants: {
      direction: {
        prev: ['left-3.2'],
        next: ['right-3.2'],
      },
    },
  }
);

export const cvaGalleryButtonIcon = cva(['ReviewPopupStyles-cvaGalleryButtonIcon', 'w-1.6 h-1.6', 'stroke-cBlack'], {
  variants: {
    direction: {
      prev: ['-rotate-180'],
      next: [''],
    },
  },
});

export const cvaPagination = cva(['ReviewPopupStyles-cvaPagination', '']);

export const cvaRight = cva(['ReviewPopupStyles-cvaRight', 'overflow-y-auto', 'w-[33.9rem] h-full', 'p-3.2']);

export const cvaName = cva(['ReviewPopupStyles-cvaName', 'mb-0.4', 'text-bodyL font-semibold']);

export const cvaText = cva(['ReviewPopupStyles-cvaText', 'text-bodyL text-cBlack80', 'mb-3.2']);

export const cvaRating = cva(['ReviewPopupStyles-cvaRating', 'mb-2.4']);
